import type { Strings } from './strings.js';

/**
 * Arabic. Right to left - the kiosk sets `dir="rtl"` on the document for this
 * language, see `applyDirection` in ./index.ts.
 */
export const ar: Strings = {
  languageName: 'العربية',
  welcome: 'أهلاً وسهلاً',
  chooseReason: 'كيف يمكننا مساعدتك؟',
  back: 'رجوع',
  cancel: 'إلغاء',
  next: 'متابعة',
  submit: 'إرسال التسجيل',
  submitting: 'جارٍ الإرسال',
  yourDetails: 'بياناتك',
  optional: 'اختياري',
  required: 'حقل إلزامي',
  requiredHint: 'يرجى تعبئة الحقول المحددة.',
  fieldRequired: 'يرجى إكمال هذا الحقل.',
  fieldInvalid: 'يرجى التحقق من هذا الإدخال.',
  pleaseSelect: 'يرجى الاختيار',
  search: 'بحث',
  noResults: 'لا توجد نتائج',
  noOptions: 'لا تتوفر هنا خيارات حالياً. يرجى التوجه إلى أحد الموظفين.',
  stepReason: 'سبب الزيارة',
  stepDetails: 'البيانات',
  stepDone: 'تم',
  thankYou: 'شكراً لك!',
  submitted: 'تم إرسال تسجيلك.',
  waitHint: 'يرجى الجلوس. سيتم استدعاؤك قريباً.',
  scanFormHint: 'امسح الرمز بهاتفك لأخذ النموذج معك.',
  ticketNumber: 'رقم انتظارك هو',
  queuedTitle: 'شكراً لك!',
  queuedHint: 'تم حفظ تسجيلك وسيتم إرساله تلقائياً. يرجى الجلوس.',
  errorTitle: 'للأسف لم تنجح العملية',
  errorHint: 'يرجى المحاولة مرة أخرى أو التوجه إلى أحد الموظفين.',
  tryAgain: 'حاول مرة أخرى',
  startOver: 'البدء من جديد',
  closedTitle: 'إدارتنا مغلقة حالياً',
  closedHint: 'يمكنك التسجيل رغم ذلك - سنتواصل معك في يوم العمل التالي.',
  closedCallUs: 'يمكنك الاتصال بنا على الرقم',
  continueAnyway: 'التسجيل على أي حال',
  appointmentQuestion: 'هل لديك موعد؟',
  appointmentYes: 'نعم، لدي موعد',
  appointmentNo: 'لا، ليس لدي موعد',
  visitingWhom: 'من تود زيارته؟',
  privacyTitle: 'حماية البيانات',
  privacyAccept: 'لقد قرأت إشعار حماية البيانات.',
  privacyRequired: 'يرجى تأكيد إشعار حماية البيانات.',
  offline: 'غير متصل',
  offlineHint: 'لا يوجد اتصال - يتم حفظ التسجيلات وإرسالها لاحقاً.',
  pendingCount: 'تسجيل محفوظ',
  idleWarning: 'سيتم حذف إدخالاتك بعد قليل.',
  pairTitle: 'ربط الجهاز اللوحي',
  pairHint: 'يرجى إدخال رمز الاقتران من الإدارة.',
  pairPlaceholder: 'ABCD-1234',
  pairButton: 'ربط',
  pairError: 'الرمز غير صالح أو انتهت صلاحيته.',
  pairSuccess: 'تم ربط الجهاز اللوحي',
  loading: 'جارٍ التحميل',
  notConfigured: 'لم يتم إعداد أنواع الزيارات',
  notConfiguredHint: 'يرجى التوجه إلى أحد الموظفين.',
  adminLink: 'الإدارة',
  pairCodeHint: 'يُنشأ الرمز في لوحة الإدارة ضمن «المواقع والأجهزة اللوحية» وصلاحيته محدودة بوقت معيّن.',
  setupTitle: 'لم يتم الإعداد بعد',
  setupText:
    'لم يتم إعداد هذا النظام بعد. يقوم معالج الإعداد بإنشاء المسؤول والمؤسسة والموقع والجهاز اللوحي الأول.',
  setupButton: 'بدء الإعداد',
  setupAfter: 'بعد ذلك سيظهر هنا حقل رمز الاقتران تلقائيًا.',
};
